module.exports = __webpack_public_path__ + "static/media/border-right.859cfd9b.svg";